import React from "react";
import Link from "@mui/material/Link";
import {Typography} from "@mui/material";
import {useTheme} from "@mui/styles";

const Copyright = ({isLogin = false}) => {
    let theme = useTheme();

    return (
        <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            style={{
                paddingBottom: "10px",
                color: isLogin ? "#FFF" : (theme.palette.mode === "light" ? "#000" : "#FFF")
            }}
        >
            {"Copyright © "}
            <Link color="inherit" href="http://www.atlantisapp.it/">
                Atlantis 2025
            </Link>
        </Typography>
    )
}

export default React.memo(Copyright);
